import cx from 'classnames';
import {useCallback, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useRequestLogin} from '~/common/fabric/Card/components/LoginModal/hooks/useRequestLogin';
import {subscribeToUserStateChanges, type UserData} from '~/common/utils/userStateSync';
import {Button} from '~library/atoms/Button';
import {userLoggedIn} from '~library/organisms/LoginModal/reducer/actions';
import {FavoriteHeartIcon} from '~library/svg/v2/FavoriteHeartIcon';

type FavoritesHeartProps = {
  identifier: string;
  onClick?: () => void;
  favorited?: boolean;
};

export const FavoritesHeart = ({identifier, onClick, favorited}: FavoritesHeartProps) => {
  const dispatch = useDispatch();
  const {loggedIn, requestLogin} = useRequestLogin();

  // Subscribe to user state changes from other stores
  useEffect(() => {
    return subscribeToUserStateChanges((userData: UserData) => {
      if (userData?.userId) {
        dispatch(
          userLoggedIn(
            userData.userId,
            userData.userName,
            userData.subscriptionPlanName,
            userData.email,
            userData.avatarDisk,
            userData.imgUrl,
            userData.initials,
            userData.firstName
          )
        );
      }
    });
  }, [dispatch]);

  const onClickHandler = useCallback(async () => {
    let successfulLogin = false;

    if (!loggedIn) {
      successfulLogin = await requestLogin();
    }

    if ((successfulLogin || loggedIn) && typeof onClick === 'function') {
      onClick();
    }
  }, [loggedIn, requestLogin, onClick]);

  return (
    <Button
      className={cx('gallery-template_favorite-btn', {
        'gallery-template_favorite-btn--selected': favorited,
      })}
      variant="transparent"
      size="small"
      data-qa-id={`button-toggle-favorite_${identifier}-${favorited ? 'selected' : ''}`}
      onClick={onClickHandler}
      override
      disableProcessing
    >
      <FavoriteHeartIcon />
    </Button>
  );
};
